import { render } from "./generic-listing.vue?vue&type=template&id=54b682ee"
import script from "./generic-listing.vue?vue&type=script&lang=js"
export * from "./generic-listing.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\MVC\\wwwroot\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__